import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 45000 }
  }
  static targets = [ "online", "rest" ]

  connect() {
    this.refresh = this.refresh.bind(this)
    this.onVisibility = this.onVisibility.bind(this)
    this.startTimer()
    document.addEventListener("visibilitychange", this.onVisibility)
    this.refresh()
  }

  disconnect() {
    this.stopTimer()
    document.removeEventListener("visibilitychange", this.onVisibility)
  }

  onVisibility() {
    if (document.hidden) {
      this.stopTimer()
      return
    }
    this.refresh()
    this.startTimer()
  }

  startTimer() {
    this.stopTimer()
    this.timer = window.setInterval(this.refresh, this.intervalValue)
  }

  stopTimer() {
    if (this.timer) window.clearInterval(this.timer)
    this.timer = null
  }

  refresh() {
    if (document.hidden || !this.urlValue) return

    window.fetch(this.urlValue, {
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then((response) => {
      if (!response.ok) return
      return response.json()
    }).then((data) => {
      if (!data) return
      if (this.hasOnlineTarget) this.onlineTarget.textContent = data.online_text
      if (this.hasRestTarget) this.restTarget.textContent = ` · ${data.visitors_text} · stats→`
      this.element.setAttribute("aria-label", `${data.online_text}, ${data.visitors_text}. Stats`)
    }).catch(() => {})
  }
}
